<div class="button-row">
  <aero-button
    *ngIf="showUseTemplateButton"
    (click)="commands.copyPageAsTemplate($event)"
    label="{{ 'ajs.button_template' | transloco }}"
    svgIconKey="clone"
    class="page-header-button template-button"
    [aeroStyle]="buttonStyle"
    [size]="buttonSize"
  ></aero-button>

  <bulb-menu-list-panel [menuItems]="pageMenuItems" [useFixedPosition]="true" class="bulb-menu-list-panel">
    <ng-template #buttonTemplate>
      <button #toggleEl class="ghost-button">
        <svg-icon key="ellipsis-h" fontSize="2.5em" class="menu-list-button page-triple-dot-button">
        </svg-icon>
      </button>
    </ng-template>
  </bulb-menu-list-panel>

  <bulb-submit-assignment-button
    *ngIf="this.unit?.assignment && showSubmitButton"
    [unit]="this.unit"
    [isShareDisabled]="isShareDisabled"
  >
  </bulb-submit-assignment-button>

  <bulb-share-button *ngIf="showShareMenu && !isViewOnly"
                     [unitId]="unitId"
                     [parentUnitId]="parentUnitId"
                     [showSharePanel] = "showSharePanel"
                     [disabled]="isShareDisabled">
    <ng-template #toggleButton>
      <aero-button
        #toggleElRef
        [disabled]="isShareDisabled"
        label="{{ 'sharePanel.shareButton' | transloco }}"
        svgIconKey="paper-plane"
        class="page-header-button share-button"
        [aeroStyle]="buttonStyle"
        [size]="buttonSize"
        pTooltip="{{ 'sharePanel.disabled.titleToShare' | transloco }}"
        tooltipPosition="bottom"
        [tooltipDisabled]="!isShareDisabled"
      ></aero-button>
    </ng-template>
  </bulb-share-button>
</div>
